import script from "./BookingPaymentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingPaymentModal.vue?vue&type=script&setup=true&lang=js"

import "@vueform/toggle/themes/default.css?vue&type=style&index=0&lang=css"
import "./BookingPaymentModal.vue?vue&type=style&index=1&id=f28a29ac&scoped=true&lang=scss"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f28a29ac"]])

export default __exports__